const educationData = [
    {
        id: 0,
        institution: 'Bangladesh University of Engineering and Technology - (BUET)',
        location: '',
        faculty: 'Institute of Information and Communication Technology (IICT)',
        link: 'https://www.buet.ac.bd/',
        degree: 'M.Sc. Engineering (ICT)',
        buttonText: 'M.Sc.Engineering.(ICT)',
        background: '/img/buet.jpeg',
    },
    {
        id: 1,
        institution: 'Patuakhali Science and Technology University - (PSTU)',
        location: '',
        faculty: 'Faculty of Computer Science and Engineering',
        link: 'http://www.pstu.ac.bd/',
        degree: 'B.Sc. Engineering (CSE)',
        buttonText: 'B.Sc. Engineering.(CSE)',
        background: '/img/pstu.jpeg',

    },
    {
        id: 2,
        institution: 'Govt. Syed Hatem Ali College',
        // location: 'Barishal',
        faculty: 'Science Group',
        link: 'http://www.gshac.gov.bd',
        degree: 'H.S.C.',
        buttonText: 'H.S.C.',

    },
    {
        id: 3,
        institution: 'Jhalokathi Govt. High School',
        // location: 'Jhalokathi',
        faculty: 'Science Group',
        link: 'http://www.barisalboard.gov.bd/101633/news.html',
        degree: 'J.S.C. & S.S.C.',
        buttonText: 'J.S.C. & S.S.C.',

    }
];

export default educationData;
